import fileUploadAPI from 'api/ApiActions/Common/FileUpload'

const FroalaConfig = {
  key: process.env.REACT_APP_FROALA_KEY,
  events: {
    'image.beforeUpload': function (images: File[]) {
      fileUploadAPI
        .uploadFile(images[0])
        .then(({ data }) => {
          if (process.env.NODE_ENV === 'production') {
            return data.data.url
          }

          return location.origin + data.data.url
        })
        .then((this as any).image.insert)
      return false
    },
  },
  imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
  pasteDeniedAttrs: ['style'],
  attribution: false,
  charCounterCount: true,
  videoInsertButtons: ['videoByURL', 'videoEmbed'],
  toolbarInline: false,
  quickInsertEnabled: false,
  tableStyles: {
    noBorder: 'No Borders',
    dashedBorders: 'Dashed Borders',
    alternateRows: 'Alternate Rows',
  },
  htmlAllowedAttrs: [
    'accept',
    'accept-charset',
    'accesskey',
    'action',
    'align',
    'allowfullscreen',
    'allowtransparency',
    'alt',
    'aria-.*',
    'async',
    'autocomplete',
    'autofocus',
    'autoplay',
    'autosave',
    'background',
    'bgcolor',
    'border',
    'charset',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'color',
    'cols',
    'colspan',
    'content',
    'contenteditable',
    'contextmenu',
    'controls',
    'coords',
    'data',
    'data-.*',
    'datetime',
    'default',
    'defer',
    'dir',
    'dirname',
    'disabled',
    'download',
    'draggable',
    'dropzone',
    'enctype',
    'for',
    'form',
    'formaction',
    'frameborder',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'http-equiv',
    'icon',
    'id',
    'ismap',
    'itemprop',
    'keytype',
    'kind',
    'label',
    'lang',
    'language',
    'list',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'mozallowfullscreen',
    'multiple',
    'muted',
    'name',
    'novalidate',
    'open',
    'optimum',
    'pattern',
    'ping',
    'placeholder',
    'playsinline',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'reversed',
    'rows',
    'rowspan',
    'sandbox',
    'scope',
    'scoped',
    'scrolling',
    'seamless',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'src',
    'srcdoc',
    'srclang',
    'srcset',
    'start',
    'step',
    'summary',
    'spellcheck',
    'style',
    'tabindex',
    'target',
    'title',
    'type',
    'translate',
    'usemap',
    'value',
    'valign',
    'webkitallowfullscreen',
    'width',
    'wrap',
    'allow',
  ],
  htmlRemoveTags: [],
  fontSize: [
    '8',
    '9',
    '10',
    '11',
    '12',
    '14',
    '16',
    '18',
    '24',
    '30',
    '36',
    '48',
    '60',
    '72',
    '96',
  ],
  htmlExecuteScripts: false,
  htmlAllowComments: false,
  imagePaste: false,
  videoResize: false,
  videoEditButtons: [
    'videoReplace',
    'videoRemove',
    'videoDisplay',
    'videoAlign',
    'autoplay',
  ],
  videoResponsive: true,
  toolbarButtons: [
    'insertImage',
    'insertLink',
    'formatOL',
    'formatUL',
    'paragraphFormat',
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    'clearFormatting',
    'undo',
  ],
  htmlAllowedEmptyTags: [
    'textarea',
    'a',
    'iframe',
    'object',
    'video',
    'style',
    'script',
    '.fa',
    '.fr-emoticon',
    '.fr-inner',
    'path',
    'line',
    'hr',
  ],
  sticky: false,
  minHeight: 100,
  zIndex: 1001,
}

export { FroalaConfig }
